import type { Dispatch, SetStateAction } from 'react';
import type {
  MarketLookupOption,
  CodeDescriptionLookupOption,
} from 'src/api/services/policy.service';

import type { PolicyEditDraft } from './policy-information.types';

export type MarketOption = Pick<MarketLookupOption, 'code' | 'description'>;
export type LiabilityOption = {
  value: string;
  label: string;
};
export type SelectOption = {
  value: string;
  label: string;
};

export type PolicyDraftSetter = Dispatch<SetStateAction<PolicyEditDraft>>;

export const OTHER_LIABILITY_VALUE = 'OTHER';

export const accidentLiabilityOptions: LiabilityOption[] = [
  { value: '100000', label: '100,000' },
  { value: '500000', label: '500,000' },
  { value: '1000000', label: '1,000,000' },
];

export const diseasePolicyLiabilityOptions: LiabilityOption[] = [
  { value: '500000', label: '500,000' },
  { value: '1000000', label: '1,000,000' },
  { value: '2500000', label: '2,500,000' },
  { value: '5000000', label: '5,000,000' },
  { value: '10000000', label: '10,000,000' },
];

export const diseaseEmployeeLiabilityOptions: LiabilityOption[] = [
  { value: '100000', label: '100,000' },
  { value: '500000', label: '500,000' },
  { value: '1000000', label: '1,000,000' },
];

export const formFieldWrapperSx = {
  alignItems: 'center',
  display: 'flex',
  mt: 3,
};

export const tableFieldSx = {
  '& .MuiInputBase-root': {
    alignItems: 'center',
  },
};

export function getLiabilitySelectValue(value: string, options: LiabilityOption[]): string {
  return options.some((option) => option.value === value) ? value : OTHER_LIABILITY_VALUE;
}

export function getLiabilityValueAfterSelect(
  currentValue: string,
  selectedValue: string,
  options: LiabilityOption[]
): string {
  if (selectedValue !== OTHER_LIABILITY_VALUE) {
    return selectedValue;
  }

  return options.some((option) => option.value === currentValue) ? '' : currentValue;
}

export function buildSelectOptionsWithLegacyValue(
  currentValue: string,
  options: SelectOption[],
  legacyDisplayValue?: string | null
): SelectOption[] {
  if (!currentValue || options.some((option) => option.value === currentValue)) {
    return options;
  }

  return [
    {
      value: currentValue,
      label: legacyDisplayValue?.trim() || currentValue,
    },
    ...options,
  ];
}

export function toSelectOptions(lookups: CodeDescriptionLookupOption[]): SelectOption[] {
  return lookups.map((lookup) => ({ value: lookup.code, label: lookup.description }));
}
